import React from "react";
import { AlertTriangle, ChevronRight } from "lucide-react";

interface InactivityModalProps {
  show: boolean;
  countdown: number;
  onContinue: () => void;
}

export const InactivityModal = ({
  show,
  countdown,
  onContinue,
}: InactivityModalProps) => {
  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="relative mx-4 w-full max-w-3xl rounded-[1.25rem] border-4 border-[#008FD3] bg-white/95 p-14 shadow-[0_35px_120px_rgba(0,143,211,0.3)]">
        <div className="flex flex-col items-center gap-14 text-center">
          <div className="flex flex-col items-center gap-6">
            <div className="flex h-24 w-24 items-center justify-center rounded-full bg-[#008FD3]/10">
              <AlertTriangle className="h-14 w-14 text-[#008FD3]" />
            </div>
            <h2 className="text-5xl font-extrabold text-[#2C2D2F]">
              일시 정지 중
            </h2>
            <p className="text-3xl text-[#3E3A39]">
              계속 진행하시겠습니까?
              <br />
              {countdown}초 후 자동으로 초기화면으로 돌아갑니다.
            </p>
          </div>

          <div className="flex w-full">
            <button
              type="button"
              onClick={onContinue}
              className="group flex-1 rounded-[1.25rem] px-8 py-6 text-3xl font-extrabold uppercase tracking-[0.35em] transition-all duration-300 flex items-center justify-center gap-4 bg-gradient-to-r from-[#008FD3] via-[#0096C0] to-[#0EA5E9] text-white shadow-[0_22px_45px_rgba(0,143,211,0.4)] hover:-translate-y-1 hover:shadow-[0_30px_65px_rgba(0,143,211,0.5)]"
            >
              <span>계속 진행</span>
              <ChevronRight className="h-9 w-9 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

